import './style.scss';

import React, { useMemo } from 'react';

import { cexConfigs, dexConfigs, ECexName, IDexName } from 'web3';

interface IPlatformIconProps {
  platform: IDexName | ECexName;
  isIcon?: boolean;
  className?: string;
}

const PlatformIcon: React.FC<IPlatformIconProps> = ({ platform, isIcon, className }) => {
  const iconTradingPair = useMemo(() => {
    const config =
      platform in ECexName ? cexConfigs[platform as ECexName] : dexConfigs[platform as IDexName];

    if (isIcon) return config?.icon;

    return config?.iconText;
  }, [isIcon, platform]);

  const imageClassName = className ?? 'trading-pair-icon';
  const isInfinity = platform === 'pancakeswap_inf_cl:bsc';

  if (isInfinity) {
    return (
      <span className="trading-pair-icon__infinity">
        <img className={imageClassName} alt="" src={iconTradingPair} />
        <span className="trading-pair-icon__badge">V4</span>
      </span>
    );
  }

  return <img className={imageClassName} alt="" src={iconTradingPair} />;
};

export default PlatformIcon;
